module.exports = __webpack_public_path__ + "img/dylliardi.4a9ed686.png";